exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donate #redirect .message[data-v-06ac27f7],.oi-donate #redirect .title[data-v-06ac27f7]{width:100%}", ""]);

// exports
